import {Tracedo} from "../../entities/Tracedo";

export class TracedoFactory {

    static makeEmptyTracedo(): Tracedo {
        return {
            id: null,
            parentId: null,
            adr: false,
            ata: null,
            ataReady: null,
            atd: null,
            atdReady: null,
            bdpCntrTypeId: null,
            cargoDescription: null,
            clientRef: null,
            clientRef2: null,
            clientRef3: null,
            cntrNr: null,
            consigneeName: null,
            createdTimestamp: null,
            createdUserId: null,
            custom: null,
            customOffice: null,
            declarant: null,
            deleted: false,
            deliveryContactId: null,
            depotId: null,
            destAddressCity: null,
            destAddressCountryId: null,
            destAddressName: null,
            destAddressStreet: null,
            destAddressStreet2: null,
            destAddressZipCode: null,
            destinationContactFirstName: null,
            destinationContactLastName: null,
            destinationContactPhone: null,
            destinationContactEmail: null,
            destinationNote: null,
            driverInfo: null,
            driverUserId: null,
            etaFrom: null,
            etaTo: null,
            etdFrom: null,
            etdTo: null,
            handedOverToPerson: null,
            kindId: null,
            ldm: null,
            loadingReference: null,
            modeId: null,

            onPreCarriageExist: false,
            originAddressCity: null,
            originAddressCountryId: null,
            originAddressName: null,
            originAddressStreet: null,
            originAddressStreet2: null,
            originAddressZipCode: null,
            originContactFirstName: null,
            originContactLastName: null,
            originContactPhone: null,
            originContactEmail: null,
            originNote: null,
            pickupContactId: null,
            rejdar: null,
            roadTypeId: null,
            sealNr: null,
            shipperName: null,
            spz: null,
            token: null,
            trcStatusId: null,
            truckTypeId: null,
            unloadingReference: null,
            vessel: null,
            extId: null,

            driverNote: null,
            adrClass: null,
            packingGroup: null,
            un: null,
            chargeableVolume: null,
            kgs: null,
            km: null,
            cbm: null,
            colli: null,

            sumKgs: null,
            sumCbm: null,
            sumColli: null,

            rdlFrom: null,
            rdlTo: null,
            ecrFrom: null,
            ecrTo: null,
            mbl: null,
            hbl: null,
            voyageNr: null,
            trainNr: null,
            commodity: null,
            commodityValue: null,

            metAtb: null,
            metBookingNr: null,
            metPin: null,

            currencyId: null,
            pickupAddressId: null,
            deliveryAddressId: null,

            // Subjects
            customerPartnerId: null,
            customerPartnerPicUserId: null,

            myField: null,
            mySubjectId: null,
            myPicUserId: null,
            myInvoicingStatusId: null,
            mySeasonId: null,
            myUzp: null,

            supplierPartnerId: null,
            supplierPartnerUzp: null,
            supplierPartnerPicUserId: null,

            sellPrice: null,
            sellPriceCurrencyId: null,
            purchasePrice: null,
            purchasePriceCurrencyId: null,

            incotermsId: null,

            // Custom fields
            fields: {},

            // Checkpoints
            checkpoints: [],

            // Origin + Destination colli, kgs, colliTypeId
            originColli: null,
            originKgs: null,
            originColliTypeId: null,
            destinationColli: null,
            destinationKgs: null,
            destinationColliTypeId: null,

            destinationRamp: {
                id: null,
                name: null,
            },
            originRamp: {
                id: null,
                name: null,
            },
            destinationRampId: null,
            destinationRampName: null,
            originRampId: null,
            originRampName: null,

            carriersOriginData: null,
            carriersDestinationData: null,

            cancelRequest: null,
            serviceTypeId: null,
            hs: null,
        }
    }

}